// extracted by mini-css-extract-plugin
export default {"bttn":"Loginbutton_bttn__q6iCD"};